import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { ContentCard } from "@/components/ContentCard";
import { useAuth } from "@/context/AuthContext";
import { useUI } from "@/context/UIContext";
import api from "@/lib/api";

export default function MyList() {
  const { user, loading } = useAuth();
  const { myListIds } = useUI();
  const [items, setItems] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) { navigate("/login"); return; }
    api.get("/mylist").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [user, loading, myListIds.size]);

  return (
    <Layout>
      <div className="pt-28 px-4 md:px-12 pb-12">
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-white fade-up">My List</h1>
        <p className="text-slate-400 mt-2">Everything you've saved to watch later.</p>

        {items === null ? (
          <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {Array.from({ length: 6 }).map((_, i) => <div key={i} className="aspect-[2/3] rounded-lg skeleton" />)}
          </div>
        ) : items.length === 0 ? (
          <div className="text-center py-24">
            <div className="text-slate-400">Your list is empty.</div>
            <button onClick={() => navigate("/")} className="mt-4 bg-[var(--nik-blue)] hover:bg-[var(--nik-blue-hover)] px-6 py-2.5 rounded-lg font-semibold text-white transition-colors">
              Browse titles
            </button>
          </div>
        ) : (
          <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 pb-8">
            {items.map((item) => (
              <div key={item.id} className="flex justify-center"><ContentCard item={item} /></div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
